import { parseUTC } from '../../utils';

const PURGE_AFTER_DAYS = 90;

function fmt(date) {
  return date.toLocaleDateString('es-AR', { day: '2-digit', month: '2-digit', year: 'numeric' });
}

// #180 — el cliente dado de baja no corre backups; los 90 días son sólo
// retención de los datos en Wasabi. Vista de admin.
export function DeactivatedClientBanner({ client }) {
  if (!client || client.active !== false) return null;
  const deletedAt = client.deleted_at ? parseUTC(client.deleted_at) : null;
  const purgeAt = deletedAt ? new Date(deletedAt.getTime() + PURGE_AFTER_DAYS * 86400000) : null;
  return (
    <div data-testid="deactivated-client-banner" style={{
      background: 'rgba(255,60,60,0.1)', border: '1px solid var(--red)', color: 'var(--red)',
      padding: '10px 16px', marginBottom: 16, fontSize: 13, fontFamily: 'var(--mono)',
    }}>
      {deletedAt
        ? `Dado de baja el ${fmt(deletedAt)}. Los backups están detenidos. Los datos en Wasabi se eliminan el ${fmt(purgeAt)} salvo que se reactive el cliente.`
        : 'Cliente dado de baja. Los backups están detenidos. Los datos en Wasabi se eliminan a los 90 días de la baja salvo que se reactive el cliente.'}
    </div>
  );
}
